var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { instanceToPlain, plainToClass } from 'class-transformer';
import queries from 'constants/queries';
import { OrderEntity } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from './ApiService';
var EMPTY_FILTERS = {};
var OrderEntityService = /** @class */ (function (_super) {
    __extends(OrderEntityService, _super);
    function OrderEntityService() {
        var _this = _super.call(this) || this;
        _this.root = 'order_entities';
        _this.successMessage = '';
        return _this;
    }
    OrderEntityService.prototype.useOrderEntities = function (filters) {
        var _this = this;
        if (filters === void 0) { filters = EMPTY_FILTERS; }
        var params = {};
        if (filters.entity_type) {
            params.entity_type = filters.entity_type;
        }
        if (filters.is_enabled !== undefined) {
            params.is_enabled = filters.is_enabled;
        }
        if (filters.code) {
            params.code = filters.code;
        }
        if (filters.clinic_id != null) {
            params.clinic_id = filters.clinic_id;
        }
        return useQuery([queries.orderEntities, filters], function () {
            return _this.get(_this.root, params);
        }, {
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(OrderEntity, (data || []));
            }
        });
    };
    OrderEntityService.prototype.useOrderEntity = function (id, enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        return useQuery([queries.orderEntity, id], function () {
            return _this.get("".concat(_this.root, "/").concat(id));
        }, {
            enabled: enabled && !!id,
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(OrderEntity, data);
            }
        });
    };
    OrderEntityService.prototype.useCreateOrderEntity = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var orderEntity = _a.orderEntity, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post(_this.root, {
                data: { order_entity: instanceToPlain(orderEntity) }
            });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.orderEntities);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    OrderEntityService.prototype.useUpdateOrderEntity = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var orderEntity = _a.orderEntity, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put("".concat(_this.root, "/").concat(orderEntity.getId()), {
                data: { order_entity: instanceToPlain(orderEntity) }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                queryClient.invalidateQueries(queries.orderEntities);
                queryClient.invalidateQueries([queries.orderEntity, variables.orderEntity.getId()]);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    OrderEntityService.prototype.useAddMedicalMachine = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var orderEntityId = _a.orderEntityId, medicalMachineId = _a.medicalMachineId, isPrimary = _a.isPrimary, notes = _a.notes, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post("".concat(_this.root, "/").concat(orderEntityId, "/add_medical_machine"), {
                data: {
                    medical_machine_id: medicalMachineId,
                    is_primary: isPrimary !== false,
                    notes: notes
                }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateOrderEntity(queryClient, variables.orderEntityId);
            }
        });
    };
    OrderEntityService.prototype.useRemoveMedicalMachine = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var orderEntityId = _a.orderEntityId, medicalMachineId = _a.medicalMachineId, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.delete("".concat(_this.root, "/").concat(orderEntityId, "/remove_medical_machine"), { data: { medical_machine_id: medicalMachineId } });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateOrderEntity(queryClient, variables.orderEntityId);
            }
        });
    };
    OrderEntityService.prototype.useAssignClinic = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var orderEntityId = _a.orderEntityId, clinicId = _a.clinicId, isEnabled = _a.isEnabled, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post("".concat(_this.root, "/").concat(orderEntityId, "/assign_clinic"), {
                data: {
                    clinic_id: clinicId,
                    is_enabled: isEnabled !== false
                }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateOrderEntity(queryClient, variables.orderEntityId);
            }
        });
    };
    OrderEntityService.prototype.useUnassignClinic = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var orderEntityId = _a.orderEntityId, clinicId = _a.clinicId, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.delete("".concat(_this.root, "/").concat(orderEntityId, "/unassign_clinic"), {
                data: { clinic_id: clinicId }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateOrderEntity(queryClient, variables.orderEntityId);
            }
        });
    };
    OrderEntityService.prototype.invalidateOrderEntity = function (queryClient, id) {
        queryClient.invalidateQueries(queries.orderEntities);
        queryClient.invalidateQueries([queries.orderEntity, id]);
        this.dipatachCreationSuccess({ successMessage: this.successMessage });
    };
    OrderEntityService.getInstance = function () {
        if (!OrderEntityService.instance) {
            OrderEntityService.instance = new OrderEntityService();
        }
        return OrderEntityService.instance;
    };
    return OrderEntityService;
}(ApiService));
export default OrderEntityService;
